import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { useMemo } from 'react';
import { useSWRFetch } from './internal/useSWRFetch';
import { getProductInfoDialogProducts } from '../api';
export var useGetProductInfoDialogProducts = function useGetProductInfoDialogProducts(_ref) {
  var atpClusterId = _ref.atpClusterId,
    currentLanguage = _ref.currentLanguage,
    customerId = _ref.customerId,
    globalApiUrl = _ref.globalApiUrl,
    graphQlUrl = _ref.graphQlUrl,
    productCodes = _ref.productCodes,
    tenant = _ref.tenant,
    token = _ref.token;
  var _useSWRFetch = useSWRFetch({
      fallback: [],
      fetcher: async function fetcher() {
        return getProductInfoDialogProducts({
          atpClusterId: atpClusterId,
          currentLanguage: currentLanguage,
          customerId: customerId,
          globalApiUrl: globalApiUrl,
          graphQlUrl: graphQlUrl,
          productCodes: productCodes,
          tenant: tenant,
          token: token
        });
      },
      key: [atpClusterId, customerId, globalApiUrl, graphQlUrl, tenant, token].concat(_toConsumableArray(productCodes))
    }),
    data = _useSWRFetch.data,
    error = _useSWRFetch.error,
    fetch = _useSWRFetch.fetch,
    isLoaded = _useSWRFetch.isLoaded,
    isLoading = _useSWRFetch.isLoading;
  return useMemo(function () {
    return {
      data: data,
      error: error,
      fetch: fetch,
      isLoaded: isLoaded && data.length > 0,
      isLoading: isLoading
    };
  }, [data, error, fetch, isLoaded, isLoading]);
};